<template>

  <div>
    <!-- modal -->
    <b-modal
      ref="reassign-modal"
      hide-footer
      title="Using Component Methods"
    >
      <div class="d-block text-center">
        <h4>Seçili Kişilerin Eğitim GEçmişini Sıfırlayın</h4>
      </div>
      <hr>
      <b-list-group>
        <b-list-group-item
          v-for="(item,index) in assignUsersData"

          :key="index"
          class="d-flex justify-content-between align-items-center"
        >
          <span>{{ item.name+'('+item.email+')' }}</span>
          <b-form-checkbox
            v-model="item.selected"
            :value="1"
            :unchecked-value="0"
            name="checkbox-input"
          >
            {{ $t('Dahil Et') }}
          </b-form-checkbox>
        </b-list-group-item>

      </b-list-group>
      <hr>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="mr-2"
        type="button"
        @click="startReAssign"
      >
        {{ $t('İşlemiBaşlat') }}
      </b-button>
    </b-modal>
    <b-sidebar
      id="add-new-user-sidebar"
      :visible="isEditTrainingSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      @hidden="resetForm"
      @change="(val) => $emit('update:is-add-new-product-sidebar-active', val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">
            {{ $t('Training Kategorisi') }}
          </h5>

          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />

        </div>

        <!-- BODY -->
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >
          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(saveData)"
            @reset.prevent="resetForm"
          >

            <!-- Firma ad -->
            <validation-provider
              #default="validationContext"
              :name="$t('Eğitim Adı')"
              rules="required|min:2"
            >
              <b-form-group
                :label="$t('Eğitim Adı')"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="trainingData.name"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                {{ $t('Kaydet') }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
              >
                {{ $t('Vazgeç') }}
              </b-button>
            </div>

          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
    <!-- Filters -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>{{ $t('Show') }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>{{ $t('Entries') }}</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-if="false"
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                @click="addData"
              >
                <span class="text-nowrap">{{ $t('Eğitim Oluştur') }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refTrainingListTable"
        class="position-relative"
        :items="fetchTrainingCategories"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        small
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Actions -->
        <template #cell(emails_button)="data">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            :to="{ name: 'email-address', params: { category_id: data.item.id } }"
          >
            {{ $t('E Posta Adreslerini Görüntüle') }}
          </b-button>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item :to="{ name: 'training-edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Düzenle') }} </span>
            </b-dropdown-item>
            <b-dropdown-item @click="reAssignTraining(data.item.id)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Yeniden Ata') }} </span>
            </b-dropdown-item>
            <b-dropdown-item

              variant="danger"
              @click="deleteData(data.item.id)"
            >
              <feather-icon icon="Trash2Icon" />
              <span class="align-middle ml-50">{{ $t('Sil') }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">{{ $t('Gösterilen') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} {{ $t('Entries') }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalTrainingCategories"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable,
  BDropdown, BDropdownItem, BPagination, BSidebar, BFormGroup, BFormInvalidFeedback, BForm, BModal, BFormCheckbox, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import router from '@/router'
import useTrainingList from './useTrainingList'
import trainingStoreModule from '../trainingStoreModule'

export default {
  components: {
    BCard,
    BRow,
    BModal,
    BCol,
    BSidebar,
    BListGroup,
    BListGroupItem,
    BForm,
    BFormCheckbox,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      assignUsersData: [],
      selectedTrainingId: 0,
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    deleteData(id) {
      this.$swal({
        title: this.$t('Emin Misiniz ?'),
        text: this.$t('Eğitimi Silmek İstediğinizden Emin Misiniz ? (Bu işlem geri alınamaz.)'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Silme İşlemini Onayla'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('app-training/deleteTraining', { id })
            .then(() => {
              this.$refs.refTrainingListTable.refresh()
              this.showSuccessMessage()
            })
            .catch(() => {
              this.showErrorMessage()
            })
        }
      })
    },
    startReAssign() {
      store.dispatch('app-training/reAssignTraining', { training_id: this.selectedTrainingId, users_data: this.assignUsersData })
        .then(() => {
          this.showSuccessMessage()
        })
    },
    reAssignTraining(id) {
      store.dispatch('app-training/fetchSingleTraining', { id })
        .then(response => {
          this.selectedTrainingId = response.data.data.id
          response.data.data.assign_users.forEach(val => {
            this.assignUsersData.push({
              name: `${val.name} ${val.surname}`, email: val.email, id: val.id, selected: 0,
            })
          })

          this.showSuccessMessage()
        })

      this.$refs['reassign-modal'].show()
    },
    showSuccessMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarılı'), {
        title: this.$t('İşlem Başarılı'),
        variant: 'success',
        solid: false,
      })
    },
    showErrorMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarısız'), {
        title: this.$t('İşlem Başarısız'),
        variant: 'danger',
        solid: false,
      })
    },
    saveData() {
      store.dispatch('app-training/addTraining', this.trainingData)
        .then(response => {
          this.showSuccessMessage()
          router.push({ name: 'training-edit', params: { id: response.data.data.id } })
        })
    },
    editData(item) {
      this.trainingData = JSON.parse(JSON.stringify(item))
      this.isEditTrainingSidebarActive = true
    },
    addData() {
      this.resetTrainingData()
      this.isEditTrainingSidebarActive = true
    },
    addIsSuccess(id) {
      this.editTrainingId = id
      this.isEditTrainingSidebarActive = true
    },
  },
  setup() {
    const APP_STORE_MODULE_NAME = 'app-training'

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, trainingStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })
    const editTrainingId = ref(0)
    const isAddNewTrainingSidebarActive = ref(false)
    const isEditTrainingSidebarActive = ref(false)
    const trainingData = ref(null)
    const blankTrainingData = {
      id: 0,
      name: '',
    }

    const {
      fetchTrainingCategories,
      tableColumns,
      perPage,
      currentPage,
      totalTrainingCategories,
      dataMeta,

      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTrainingListTable,
      refetchData,

      // UI

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useTrainingList()
    const resetTrainingData = () => {
      trainingData.value = JSON.parse(JSON.stringify(blankTrainingData))
    }
    resetTrainingData()
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetTrainingData)
    return {

      // Sidebar
      isAddNewTrainingSidebarActive,
      isEditTrainingSidebarActive,
      fetchTrainingCategories,
      tableColumns,
      perPage,
      currentPage,
      totalTrainingCategories,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      refFormObserver,
      trainingData,
      resetTrainingData,
      getValidationState,
      resetForm,
      editTrainingId,
      isSortDirDesc,
      refTrainingListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      blankTrainingData,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
